<template>
  <k-progress style="width: 100%" :percent="value" :color="getColor"></k-progress>
</template>

<script>
import KProgress from 'k-progress';

export default {
  name: "AncestrylineProgressBar",
  components: {KProgress},

  props: {
    showValue: {type: Boolean, default: true},
    value: {type: Number, default: 0},
  },

  methods: {

    getColor(percent) {
      if(percent < 20){
        return '#E74C3C';
      } else if(percent < 60) {
        return '#fadb14';
      } else if(percent < 80) {
        return '#13c2c2';
      } else if(percent < 100) {
        return '#00bc8c';
      } else {
        return '#389e0d';
      }
    }

  }

}
</script>

<style scoped>

</style>